var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 240,
    viewBox: "0 0 228 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_2148)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.976 201.473C157.976 201.473 158.002 201.44 158.021 201.421C158.034 201.408 158.047 201.388 158.067 201.375C158.08 201.356 158.093 201.343 158.112 201.323C158.125 201.304 158.138 201.291 158.158 201.272C158.171 201.252 158.184 201.239 158.203 201.22C158.216 201.2 158.229 201.187 158.249 201.168C158.262 201.155 158.275 201.135 158.294 201.122C158.307 201.103 158.32 201.09 158.34 201.07C158.353 201.051 158.366 201.038 158.385 201.019C158.398 200.999 158.411 200.986 158.431 200.967C158.444 200.947 158.457 200.934 158.476 200.915C158.489 200.902 158.502 200.882 158.522 200.869C158.535 200.85 158.548 200.837 158.567 200.824C158.58 200.804 158.593 200.791 158.613 200.772C158.626 200.753 158.639 200.74 158.658 200.72C158.671 200.701 158.684 200.688 158.704 200.668C158.717 200.655 158.73 200.636 158.749 200.623C158.762 200.603 158.775 200.59 158.795 200.571C158.808 200.551 158.821 200.538 158.84 200.519C158.853 200.506 158.866 200.487 158.886 200.474C158.899 200.454 158.912 200.441 158.931 200.422C158.944 200.409 158.957 200.389 158.977 200.376C158.99 200.357 159.003 200.344 159.022 200.324C159.035 200.305 159.048 200.292 159.068 200.272C159.081 200.253 159.094 200.24 159.113 200.221C159.126 200.201 159.139 200.188 159.159 200.169C159.172 200.156 159.185 200.136 159.204 200.123C159.217 200.104 159.23 200.091 159.25 200.071C159.263 200.052 159.276 200.039 159.295 200.019C159.308 200 159.321 199.987 159.341 199.968C159.354 199.948 159.367 199.935 159.386 199.916C159.399 199.903 159.412 199.883 159.432 199.87C159.445 199.851 159.458 199.838 159.477 199.818C159.49 199.805 159.503 199.786 159.523 199.773C159.536 199.754 159.549 199.741 159.568 199.721C159.581 199.702 159.594 199.689 159.614 199.669C159.627 199.656 159.64 199.637 159.659 199.624C159.672 199.604 159.685 199.591 159.705 199.572C159.718 199.552 159.731 199.539 159.75 199.52C159.763 199.507 159.776 199.488 159.796 199.475C159.809 199.455 159.822 199.442 159.841 199.423C159.854 199.41 159.867 199.39 159.887 199.377C159.9 199.358 159.913 199.345 159.932 199.325C159.945 199.306 159.958 199.293 159.978 199.273C159.991 199.254 160.004 199.241 160.023 199.222C160.036 199.202 160.049 199.189 160.069 199.17C160.082 199.157 160.095 199.137 160.114 199.124C160.127 199.105 160.14 199.092 160.16 199.072C160.173 199.053 160.186 199.04 160.205 199.02C160.218 199.001 160.231 198.988 160.251 198.969C160.264 198.949 160.277 198.936 160.296 198.917C160.309 198.904 160.322 198.884 160.342 198.871C160.355 198.852 160.368 198.839 160.387 198.819C160.4 198.806 160.413 198.787 160.433 198.774C160.446 198.754 160.459 198.741 160.478 198.722C160.491 198.703 160.504 198.69 160.524 198.67C160.537 198.657 160.55 198.638 160.569 198.625C160.582 198.605 160.595 198.592 160.615 198.573C160.628 198.553 160.641 198.54 160.66 198.521C160.673 198.508 160.686 198.489 160.706 198.476C160.719 198.456 160.732 198.443 160.751 198.424C160.764 198.411 160.777 198.391 160.797 198.378C160.81 198.359 160.823 198.346 160.842 198.326C160.855 198.307 160.868 198.294 160.888 198.274C160.901 198.255 160.914 198.242 160.933 198.223C160.946 198.203 160.959 198.19 160.979 198.171C160.992 198.158 161.005 198.138 161.024 198.125C161.037 198.106 161.05 198.093 161.07 198.073C161.083 198.054 161.096 198.041 161.115 198.021C161.128 198.002 161.141 197.989 161.161 197.97C161.174 197.95 161.187 197.937 161.206 197.918C161.219 197.905 161.232 197.885 161.252 197.872C161.265 197.853 161.278 197.84 161.297 197.82C161.31 197.807 161.323 197.788 161.343 197.775C161.356 197.755 161.369 197.742 161.388 197.723C161.401 197.704 161.414 197.691 161.434 197.671C161.447 197.658 161.46 197.639 161.479 197.626C161.492 197.606 161.505 197.593 161.525 197.574C161.538 197.554 161.551 197.541 161.57 197.522C161.583 197.509 161.596 197.489 161.616 197.477C161.629 197.457 161.642 197.444 161.661 197.425C161.674 197.412 161.687 197.392 161.707 197.379C161.72 197.36 161.733 197.347 161.752 197.327C161.765 197.308 161.778 197.295 161.798 197.275C161.811 197.256 161.824 197.243 161.843 197.223C161.856 197.204 161.869 197.191 161.889 197.172C161.902 197.159 161.915 197.139 161.934 197.126C161.947 197.107 161.96 197.094 161.98 197.074C161.993 197.055 162.006 197.042 162.025 197.022C162.038 197.003 162.051 196.99 162.071 196.971C162.084 196.951 162.097 196.938 162.116 196.919C162.129 196.906 162.142 196.886 162.162 196.873C162.175 196.854 162.188 196.841 162.207 196.821C162.22 196.808 162.233 196.789 162.253 196.776C162.266 196.756 162.279 196.743 162.298 196.724C162.311 196.705 162.324 196.692 162.344 196.672C162.357 196.659 162.37 196.64 162.389 196.627C162.402 196.607 162.415 196.594 162.435 196.575C162.448 196.555 162.461 196.542 162.48 196.523C162.493 196.503 162.506 196.49 162.526 196.471C162.539 196.458 162.552 196.439 162.571 196.426C162.584 196.406 162.597 196.393 162.617 196.374C162.63 196.354 162.643 196.341 162.662 196.322C162.675 196.302 162.688 196.289 162.708 196.27C162.721 196.25 162.734 196.237 162.753 196.218C162.766 196.199 162.779 196.186 162.799 196.166C162.812 196.153 162.825 196.134 162.844 196.121C162.857 196.101 162.87 196.088 162.89 196.069C162.903 196.049 162.916 196.036 162.935 196.017C162.948 195.997 162.961 195.984 162.981 195.965C162.994 195.946 163.007 195.933 163.026 195.913C163.039 195.9 163.052 195.881 163.072 195.868C163.085 195.848 163.098 195.835 163.117 195.816C163.13 195.803 163.143 195.783 163.163 195.77C163.176 195.751 163.189 195.738 163.208 195.718C163.221 195.699 163.234 195.686 163.254 195.667C163.267 195.654 163.28 195.634 163.299 195.621C163.312 195.602 163.325 195.589 163.345 195.569C163.358 195.55 163.371 195.537 163.39 195.517C163.403 195.498 163.416 195.485 163.436 195.465C163.449 195.452 163.462 195.433 163.481 195.42C163.494 195.401 163.507 195.388 163.527 195.368C163.54 195.349 163.553 195.336 163.572 195.316C163.585 195.297 163.598 195.284 163.618 195.264C163.631 195.245 163.644 195.232 163.663 195.212C163.676 195.193 163.689 195.18 163.709 195.161C163.722 195.148 163.735 195.128 163.754 195.115C163.767 195.096 163.78 195.083 163.8 195.063C163.813 195.044 163.826 195.031 163.845 195.011C163.858 194.992 163.871 194.979 163.891 194.959C163.904 194.94 163.917 194.927 163.936 194.908C163.949 194.895 163.962 194.875 163.982 194.862C163.995 194.843 164.008 194.83 164.027 194.81C164.04 194.797 164.053 194.778 164.073 194.765C164.086 194.745 164.099 194.732 164.118 194.713C164.131 194.693 164.144 194.681 164.164 194.661C164.177 194.648 164.19 194.629 164.209 194.616C164.222 194.596 164.235 194.583 164.255 194.564C164.268 194.544 164.281 194.531 164.3 194.512C164.313 194.492 164.326 194.479 164.346 194.46C164.359 194.447 164.372 194.428 164.391 194.415C164.404 194.395 164.417 194.382 164.437 194.363C164.45 194.343 164.463 194.33 164.482 194.311C164.495 194.291 164.508 194.278 164.528 194.259C164.541 194.239 164.554 194.226 164.573 194.207C164.586 194.187 164.599 194.175 164.619 194.155C164.632 194.142 164.645 194.123 164.664 194.11C164.677 194.09 164.69 194.077 164.71 194.058C164.723 194.038 164.736 194.025 164.755 194.006C164.768 193.986 164.781 193.973 164.801 193.954C164.814 193.935 164.827 193.922 164.846 193.902C164.859 193.889 164.872 193.87 164.892 193.857C164.905 193.837 164.918 193.824 164.937 193.805C164.95 193.792 164.963 193.772 164.983 193.759C164.996 193.74 165.009 193.727 165.028 193.707C165.041 193.688 165.054 193.675 165.074 193.656C165.087 193.643 165.1 193.623 165.119 193.61C165.132 193.591 165.145 193.578 165.165 193.558C165.178 193.539 165.191 193.526 165.21 193.506C165.223 193.487 165.236 193.474 165.256 193.454C165.269 193.441 165.282 193.422 165.301 193.409C165.314 193.39 165.327 193.377 165.347 193.357C165.36 193.338 165.373 193.325 165.392 193.305C165.405 193.286 165.418 193.273 165.438 193.253C165.451 193.234 165.464 193.221 165.483 193.201C165.496 193.182 165.509 193.169 165.529 193.15C165.542 193.137 165.555 193.117 165.574 193.104C165.587 193.085 165.6 193.072 165.62 193.059C165.633 193.039 165.646 193.026 165.665 193.007C165.678 192.987 165.691 192.974 165.711 192.955C165.724 192.935 165.737 192.922 165.756 192.903C165.769 192.89 165.782 192.871 165.802 192.858C165.815 192.838 165.828 192.825 165.847 192.806C165.86 192.793 165.873 192.773 165.893 192.76C165.906 192.741 165.919 192.728 165.938 192.708C165.951 192.689 165.964 192.676 165.984 192.657C165.997 192.644 166.01 192.624 166.029 192.611C166.042 192.592 166.055 192.579 166.075 192.559C166.088 192.54 166.101 192.527 166.12 192.507C166.133 192.488 166.146 192.475 166.166 192.455C166.179 192.442 166.192 192.423 166.211 192.41C166.224 192.391 166.237 192.378 166.257 192.358C166.27 192.339 166.283 192.326 166.302 192.306C166.315 192.287 166.328 192.274 166.348 192.254C166.361 192.235 166.374 192.222 166.393 192.202C166.406 192.183 166.419 192.17 166.439 192.151C166.452 192.138 166.465 192.118 166.484 192.105C166.497 192.086 166.51 192.073 166.53 192.06C166.543 192.04 166.556 192.027 166.575 192.008C166.588 191.988 166.601 191.975 166.621 191.956C166.634 191.936 166.647 191.923 166.666 191.904C166.679 191.891 166.692 191.872 166.712 191.859C166.725 191.839 166.738 191.826 166.757 191.807C166.77 191.794 166.783 191.774 166.803 191.761C166.816 191.742 166.829 191.729 166.848 191.709C166.861 191.69 166.874 191.677 166.894 191.657C166.907 191.645 166.92 191.625 166.939 191.612C166.952 191.593 166.965 191.58 166.985 191.56C168.818 189.478 169.747 186.591 169.338 183.399L149.565 29.6205C148.746 23.2695 142.928 18.1187 136.558 18.1187H63.011C59.8195 18.1187 57.096 19.4162 55.276 21.5115C55.263 21.531 55.25 21.5439 55.2305 21.5569C55.2175 21.5764 55.2045 21.5894 55.185 21.6088C55.172 21.6283 55.159 21.6413 55.1395 21.6607C55.1265 21.6802 55.1135 21.6932 55.094 21.7126C55.081 21.7256 55.068 21.7451 55.0485 21.758C55.0355 21.7775 55.0225 21.7905 55.003 21.8099C54.99 21.8294 54.977 21.8424 54.9575 21.8618C54.9445 21.8748 54.9315 21.8943 54.912 21.9072C54.899 21.9267 54.886 21.9397 54.8665 21.9591C54.8535 21.9721 54.8405 21.9916 54.821 22.0045C54.808 22.024 54.795 22.037 54.7755 22.0564C54.7625 22.0759 54.7495 22.0889 54.73 22.1083C54.717 22.1278 54.704 22.1408 54.6845 22.1602C54.6715 22.1732 54.6585 22.1927 54.639 22.2056C54.626 22.2251 54.613 22.2381 54.5935 22.2575C54.5805 22.277 54.5675 22.29 54.548 22.3094C54.535 22.3289 54.522 22.3419 54.5025 22.3613C54.4895 22.3808 54.4765 22.3938 54.457 22.4132C54.444 22.4327 54.431 22.4457 54.4115 22.4651C54.3985 22.4781 54.3855 22.4976 54.366 22.5105C54.353 22.53 54.34 22.543 54.3205 22.556C54.3075 22.5754 54.2945 22.5884 54.275 22.6078C54.262 22.6273 54.249 22.6403 54.2295 22.6597C54.2165 22.6792 54.2035 22.6922 54.184 22.7116C54.171 22.7246 54.158 22.7441 54.1385 22.7571C54.1255 22.7765 54.1125 22.7895 54.093 22.809C54.08 22.8284 54.067 22.8414 54.0475 22.8608C54.0345 22.8738 54.0215 22.8933 54.002 22.9063C53.989 22.9257 53.976 22.9387 53.9565 22.9582C53.9435 22.9711 53.9305 22.9906 53.911 23.0036C53.898 23.023 53.885 23.036 53.8655 23.0555C53.8525 23.0749 53.8395 23.0879 53.82 23.1074C53.807 23.1268 53.794 23.1398 53.7745 23.1593C53.7615 23.1787 53.7485 23.1917 53.729 23.2112C53.716 23.2241 53.703 23.2436 53.6835 23.2566C53.6705 23.276 53.6575 23.289 53.638 23.3085C53.625 23.3279 53.612 23.3409 53.5925 23.3604C53.5795 23.3798 53.5665 23.3928 53.547 23.4123C53.534 23.4317 53.521 23.4447 53.5015 23.4642C53.4885 23.4771 53.4755 23.4966 53.456 23.5096C53.443 23.529 53.43 23.542 53.4105 23.5615C53.3975 23.5744 53.3845 23.5939 53.365 23.6069L53.3195 23.6588C53.3195 23.6588 53.2935 23.6912 53.274 23.7107C53.261 23.7236 53.248 23.7431 53.2285 23.7561C53.2155 23.7755 53.2025 23.7885 53.183 23.808C53.17 23.8274 53.157 23.8404 53.1375 23.8599C53.1245 23.8728 53.1115 23.8923 53.092 23.9053L53.0465 23.9572C53.0465 23.9572 53.0205 23.9896 53.001 24.0026C52.988 24.0221 52.975 24.035 52.9555 24.0545C52.9425 24.074 52.9295 24.0869 52.91 24.1064C52.897 24.1258 52.884 24.1388 52.8645 24.1583C52.8515 24.1777 52.8385 24.1907 52.819 24.2102C52.806 24.2232 52.793 24.2426 52.7735 24.2556C52.7605 24.2751 52.7475 24.288 52.728 24.3075C52.715 24.327 52.702 24.3399 52.6825 24.3594C52.6695 24.3788 52.6565 24.3918 52.637 24.4113C52.624 24.4307 52.611 24.4437 52.5915 24.4632C52.5785 24.4762 52.5655 24.4956 52.546 24.5086C52.533 24.5281 52.52 24.541 52.5005 24.5605C52.4875 24.5735 52.4745 24.5929 52.455 24.6059L52.4095 24.6578C52.4095 24.6578 52.3835 24.6902 52.364 24.7097C52.351 24.7227 52.338 24.7421 52.3185 24.7551C52.3055 24.7746 52.2925 24.7875 52.273 24.807C52.26 24.8265 52.247 24.8394 52.2275 24.8589C52.2145 24.8719 52.2015 24.8913 52.182 24.9043L52.1365 24.9562C52.1365 24.9562 52.1105 24.9886 52.091 25.0016C52.078 25.0211 52.065 25.0341 52.0455 25.0535C52.0325 25.073 52.0195 25.086 52 25.1054C51.987 25.1249 51.974 25.1379 51.9545 25.1573C51.9415 25.1768 51.9285 25.1897 51.909 25.2092C51.896 25.2222 51.883 25.2416 51.8635 25.2546C51.8505 25.2741 51.8375 25.2871 51.818 25.3065C51.805 25.326 51.792 25.339 51.7725 25.3584C51.7595 25.3779 51.7465 25.3909 51.727 25.4103C51.714 25.4298 51.701 25.4427 51.6815 25.4622C51.6685 25.4752 51.6555 25.4946 51.636 25.5076C51.623 25.5271 51.61 25.5401 51.5905 25.5595C51.5775 25.5725 51.5645 25.592 51.545 25.6049L51.4995 25.6568C51.4995 25.6568 51.4735 25.6893 51.454 25.7087C51.441 25.7217 51.428 25.7412 51.4085 25.7541C51.3955 25.7736 51.3825 25.7866 51.363 25.806C51.35 25.8255 51.337 25.8385 51.3175 25.8579C51.3045 25.8709 51.2915 25.8904 51.272 25.9033L51.2265 25.9552C51.2265 25.9552 51.2005 25.9877 51.181 26.0006C51.168 26.0201 51.155 26.0331 51.1355 26.0525C51.1225 26.072 51.1095 26.085 51.09 26.1044C51.077 26.1239 51.064 26.1369 51.0445 26.1563C51.0315 26.1758 51.0185 26.1888 50.999 26.2082C50.986 26.2212 50.973 26.2407 50.9535 26.2536C50.9405 26.2731 50.9275 26.2861 50.908 26.3055C50.895 26.325 50.882 26.338 50.8625 26.3574C50.8495 26.3769 50.8365 26.3899 50.817 26.4093C50.804 26.4288 50.791 26.4418 50.7715 26.4612C50.7585 26.4742 50.7455 26.4937 50.726 26.5066C50.713 26.5261 50.7 26.5391 50.6805 26.5585C50.6675 26.5715 50.6545 26.591 50.635 26.604L50.5895 26.6559C50.5895 26.6559 50.5635 26.6883 50.544 26.7077C50.531 26.7207 50.518 26.7402 50.4985 26.7532C50.4855 26.7726 50.4725 26.7856 50.453 26.8051C50.44 26.8245 50.427 26.8375 50.4075 26.857C50.3945 26.8764 50.3815 26.8894 50.362 26.9089C50.349 26.9218 50.336 26.9413 50.3165 26.9543C50.3035 26.9737 50.2905 26.9867 50.271 27.0062C50.258 27.0256 50.245 27.0386 50.2255 27.0581C50.2125 27.0775 50.1995 27.0905 50.18 27.11C50.167 27.1294 50.154 27.1424 50.1345 27.1619C50.1215 27.1813 50.1085 27.1943 50.089 27.2138C50.076 27.2267 50.063 27.2462 50.0435 27.2592C50.0305 27.2786 50.0175 27.2916 49.998 27.3111C49.985 27.3305 49.972 27.3435 49.9525 27.363C49.9395 27.3824 49.9265 27.3954 49.907 27.4149C49.894 27.4343 49.881 27.4473 49.8615 27.4668C49.8485 27.4797 49.8355 27.4992 49.816 27.5122C49.803 27.5316 49.79 27.5446 49.7705 27.5641C49.7575 27.577 49.7445 27.5965 49.725 27.6095L49.6795 27.6614C49.6795 27.6614 49.6535 27.6938 49.634 27.7133C49.621 27.7262 49.608 27.7457 49.5885 27.7587C49.5755 27.7781 49.5625 27.7911 49.543 27.8106C49.53 27.83 49.517 27.843 49.4975 27.8625C49.4845 27.8819 49.4715 27.8949 49.452 27.9144C49.439 27.9273 49.426 27.9468 49.4065 27.9598C49.3935 27.9792 49.3805 27.9922 49.361 28.0117C49.348 28.0311 49.335 28.0441 49.3155 28.0636C49.3025 28.083 49.2895 28.096 49.27 28.1155C49.257 28.1349 49.244 28.1479 49.2245 28.1674C49.2115 28.1868 49.1985 28.1998 49.179 28.2193C49.166 28.2322 49.153 28.2517 49.1335 28.2647C49.1205 28.2841 49.1075 28.2971 49.088 28.3166C49.075 28.336 49.062 28.349 49.0425 28.3685C49.0295 28.3879 49.0165 28.4009 48.997 28.4204C48.984 28.4398 48.971 28.4528 48.9515 28.4723C48.9385 28.4852 48.9255 28.5047 48.906 28.5177C48.893 28.5371 48.88 28.5501 48.8605 28.5696C48.8475 28.5825 48.8345 28.602 48.815 28.615L48.7695 28.6669C48.7695 28.6669 48.7435 28.6993 48.724 28.7188C48.711 28.7318 48.698 28.7512 48.6785 28.7642C48.6655 28.7837 48.6525 28.7966 48.633 28.8161C48.62 28.8355 48.607 28.8485 48.5875 28.868C48.5745 28.8874 48.5615 28.9004 48.542 28.9199C48.529 28.9329 48.516 28.9523 48.4965 28.9653C48.4835 28.9848 48.4705 28.9977 48.451 29.0172C48.438 29.0367 48.425 29.0496 48.4055 29.0691C48.3925 29.0885 48.3795 29.1015 48.36 29.121C48.347 29.1404 48.334 29.1534 48.3145 29.1729C48.3015 29.1923 48.2885 29.2053 48.269 29.2248C48.256 29.2378 48.243 29.2572 48.2235 29.2702C48.2105 29.2897 48.1975 29.3026 48.178 29.3156L48.1325 29.3675C48.1325 29.3675 48.1065 29.3999 48.087 29.4194C48.074 29.4389 48.061 29.4518 48.0415 29.4713C48.0285 29.4843 48.0155 29.5037 47.996 29.5167C47.983 29.5362 47.97 29.5491 47.9505 29.5686C47.9375 29.5816 47.9245 29.601 47.905 29.614L47.8595 29.6659C47.8595 29.6659 47.8335 29.6983 47.814 29.7178C47.801 29.7308 47.788 29.7502 47.7685 29.7632C47.7555 29.7827 47.7425 29.7957 47.723 29.8151C47.71 29.8346 47.697 29.8476 47.6775 29.867C47.6645 29.8865 47.6515 29.8994 47.632 29.9189C47.619 29.9319 47.606 29.9513 47.5865 29.9643C47.5735 29.9838 47.5605 29.9968 47.541 30.0162C47.528 30.0357 47.515 30.0487 47.4955 30.0681C47.4825 30.0876 47.4695 30.1006 47.45 30.12C47.437 30.1395 47.424 30.1524 47.4045 30.1719C47.3915 30.1914 47.3785 30.2043 47.359 30.2238C47.346 30.2368 47.333 30.2562 47.3135 30.2692C47.3005 30.2887 47.2875 30.3017 47.268 30.3146L47.2225 30.3665C47.2225 30.3665 47.1965 30.399 47.177 30.4184C47.164 30.4379 47.151 30.4509 47.1315 30.4703C47.1185 30.4833 47.1055 30.5028 47.086 30.5157C47.073 30.5352 47.06 30.5482 47.0405 30.5676C47.0275 30.5871 47.0145 30.6001 46.995 30.6195C46.982 30.6325 46.969 30.652 46.9495 30.6649C46.9365 30.6844 46.9235 30.6974 46.904 30.7168C46.891 30.7298 46.878 30.7493 46.8585 30.7622C46.8455 30.7817 46.8325 30.7947 46.813 30.8141C46.8 30.8336 46.787 30.8466 46.7675 30.866C46.7545 30.8855 46.7415 30.8985 46.722 30.9179C46.709 30.9374 46.696 30.9504 46.6765 30.9698C46.6635 30.9828 46.6505 31.0023 46.631 31.0152C46.618 31.0347 46.605 31.0477 46.5855 31.0671C46.5725 31.0866 46.5595 31.0996 46.54 31.119C46.527 31.1385 46.514 31.1515 46.4945 31.1709C46.4815 31.1904 46.4685 31.2034 46.449 31.2228C46.436 31.2358 46.423 31.2553 46.4035 31.2682C46.3905 31.2877 46.3775 31.3007 46.358 31.3201C46.345 31.3331 46.332 31.3526 46.3125 31.3656C46.2995 31.385 46.2865 31.398 46.267 31.4174C46.254 31.4369 46.241 31.4499 46.2215 31.4693C44.3885 33.5517 43.459 36.4385 43.8685 39.6302L63.6415 193.409C64.4605 199.76 70.2779 204.911 76.6479 204.911H149.682C152.873 204.911 155.597 203.613 157.417 201.518C157.43 201.505 157.443 201.486 157.462 201.473H157.976Z",
    fill: "url(#paint0_linear_27_2148)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.701 85.6633C154.219 85.6633 152.867 84.4632 152.672 82.9841L150.8 68.4074C150.611 66.9283 151.658 65.7282 153.14 65.7282C154.622 65.7282 155.974 66.9283 156.169 68.4074L158.041 82.9841C158.229 84.4632 157.183 85.6633 155.701 85.6633Z",
    fill: "url(#paint1_linear_27_2148)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.775 195.187H85.7414C79.3779 195.187 73.5539 190.036 72.7349 183.685L52.962 29.9059C52.143 23.555 56.641 18.4041 63.011 18.4041H136.045C142.408 18.4041 148.232 23.555 149.051 29.9059L168.824 183.685C169.643 190.036 165.145 195.187 158.775 195.187V195.187Z",
    fill: "url(#paint2_linear_27_2148)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.324 189.108H87.6264C83.2974 189.108 79.3389 185.605 78.7799 181.284L59.6245 32.2997C59.072 27.9792 62.127 24.4762 66.456 24.4762H134.153C138.482 24.4762 142.441 27.9792 143 32.2997L162.155 181.284C162.708 185.605 159.653 189.108 155.324 189.108Z",
    fill: "url(#paint3_linear_27_2148)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0334 24.4762L80.8404 27.6938C81.7894 29.3805 83.5964 30.4703 85.4359 30.4703H111.657C113.496 30.4703 115.024 29.3805 115.537 27.6938L116.519 24.4762H79.0334V24.4762Z",
    fill: "url(#paint4_linear_27_2148)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M158.775 195.187H85.7414C79.3779 195.187 73.5539 190.036 72.7349 183.685L52.962 29.9059C52.143 23.555 56.641 18.4041 63.011 18.4041H136.045C142.408 18.4041 148.232 23.555 149.051 29.9059L168.824 183.685C169.643 190.036 165.145 195.187 158.775 195.187V195.187Z",
    fill: "url(#paint5_linear_27_2148)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M155.324 189.108H87.6264C83.2974 189.108 79.3389 185.605 78.7799 181.284L59.6245 32.2997C59.072 27.9792 62.127 24.4762 66.456 24.4762H134.153C138.482 24.4762 142.441 27.9792 143 32.2997L162.155 181.284C162.708 185.605 159.653 189.108 155.324 189.108Z",
    fill: "url(#paint6_linear_27_2148)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_2148",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 24,
    width: 104,
    height: 166
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M155.324 189.108H87.6264C83.2974 189.108 79.3389 185.605 78.7799 181.284L59.6245 32.2997C59.072 27.9792 62.127 24.4762 66.456 24.4762H134.153C138.482 24.4762 142.441 27.9792 143 32.2997L162.155 181.284C162.708 185.605 159.653 189.108 155.324 189.108Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_2148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.596 75.7055H76.0369L69.8944 80.7784L68.2239 67.4862C67.6519 62.9452 70.8759 59.2669 75.4259 59.2669H113.529C118.079 59.2669 122.226 62.9452 122.798 67.4862C123.37 72.0272 120.146 75.7055 115.596 75.7055V75.7055Z",
    fill: "url(#paint7_linear_27_2148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.788 49.5037H73.2289L67.0865 54.5767L65.416 41.2845C64.844 36.7434 68.068 33.0652 72.6179 33.0652H110.721C115.271 33.0652 119.418 36.7434 119.99 41.2845C120.562 45.8255 117.338 49.5037 112.788 49.5037V49.5037Z",
    fill: "url(#paint8_linear_27_2148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2419 101.596H138.801L146.217 106.669L144.547 93.3766C143.975 88.8355 139.828 85.1573 135.278 85.1573H97.175C92.625 85.1573 89.401 88.8355 89.973 93.3766C90.545 97.9176 94.692 101.596 99.2419 101.596V101.596Z",
    fill: "url(#paint9_linear_27_2148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.096 127.486H82.5369L76.3944 132.559L74.7239 119.267C74.1519 114.726 77.3759 111.048 81.9259 111.048H120.029C124.579 111.048 128.726 114.726 129.298 119.267C129.87 123.808 126.646 127.486 122.096 127.486V127.486Z",
    fill: "url(#paint10_linear_27_2148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.742 153.37H145.301L152.717 158.443L151.047 145.151C150.475 140.61 146.328 136.932 141.778 136.932H103.675C99.1248 136.932 95.9008 140.61 96.4728 145.151C97.0448 149.692 101.192 153.37 105.742 153.37V153.37Z",
    fill: "url(#paint11_linear_27_2148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9374 164.483H146.887C150.091 164.483 153.016 167.078 153.419 170.276C153.822 173.474 151.547 176.069 148.343 176.069H88.3934C85.1889 176.069 82.264 173.474 81.861 170.276C81.458 167.078 83.7329 164.483 86.9374 164.483Z",
    fill: "#DAF1F1",
    stroke: "url(#paint12_linear_27_2148)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.294 164.483H146.88C150.085 164.483 153.01 167.078 153.413 170.276C153.816 173.474 151.541 176.069 148.336 176.069H139.75L138.294 164.483Z",
    fill: "url(#paint13_linear_27_2148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5714 38.8388L114.861 38.7934",
    stroke: "#00BDB7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3579 43.6588L115.648 43.6198",
    stroke: "#00BDB7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0155 64.7616L117.299 64.7227",
    stroke: "#00BDB7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.802 69.5881L118.085 69.5426",
    stroke: "#00BDB7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0549 116.977L124.345 116.938",
    stroke: "#00BDB7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8479 121.803L125.131 121.758",
    stroke: "#00BDB7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0244 90.5027L139.314 90.4638",
    stroke: "#007AB7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8109 95.3292L140.101 95.2838",
    stroke: "#007AB7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.524 142.381L145.814 142.335",
    stroke: "#007AB7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.317 147.201L146.601 147.162",
    stroke: "#007AB7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7949 35.0049L146.568 34.1745L142.714 20.8304L52.403 21.6477L54.7949 35.0049Z",
    fill: "url(#paint14_linear_27_2148)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0334 24.4762L80.8404 27.6938C81.7894 29.3805 83.5964 30.4703 85.4359 30.4703H111.657C113.496 30.4703 115.024 29.3805 115.537 27.6938L116.519 24.4762H79.0334V24.4762Z",
    fill: "url(#paint15_linear_27_2148)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M134.16 24.4762H130.695C135.024 24.4762 138.983 27.9792 139.542 32.2997L158.697 181.284C159.25 185.605 156.195 189.108 151.866 189.108H155.33C159.659 189.108 162.721 185.605 162.162 181.284L143.006 32.2997C142.454 27.9792 138.489 24.4762 134.16 24.4762V24.4762Z",
    fill: "url(#paint16_linear_27_2148)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M155.324 189.108H87.6264C83.2974 189.108 79.3389 185.605 78.7799 181.284L59.6245 32.2997C59.072 27.9792 62.127 24.4762 66.456 24.4762H134.153C138.482 24.4762 142.441 27.9792 143 32.2997L162.155 181.284C162.708 185.605 159.653 189.108 155.324 189.108Z",
    fill: "url(#paint17_linear_27_2148)"
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M114.257 30.4703H88.0359C86.1964 30.4703 84.3894 29.3805 83.4404 27.6938L78.2599 18.4885H120.945L118.137 27.6938C117.624 29.3805 116.096 30.4703 114.257 30.4703Z",
    fill: "url(#paint18_linear_27_2148)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M107.633 26.6364H88.5754C87.9774 26.6364 87.4314 26.1563 87.3534 25.5595C87.2754 24.9627 87.6979 24.4826 88.2959 24.4826H107.354C107.952 24.4826 108.498 24.9627 108.576 25.5595C108.654 26.1563 108.231 26.6364 107.633 26.6364Z",
    fill: "url(#paint19_linear_27_2148)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M113.333 26.6667C113.875 26.0891 113.782 25.1222 113.125 24.5071C112.468 23.8919 111.495 23.8615 110.952 24.439C110.41 25.0166 110.503 25.9835 111.16 26.5986C111.817 27.2138 112.79 27.2442 113.333 26.6667Z",
    fill: "url(#paint20_linear_27_2148)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M134.16 24.4762H130.695C135.024 24.4762 138.983 27.9792 139.542 32.2997L158.697 181.284C159.25 185.605 156.195 189.108 151.866 189.108H155.33C159.659 189.108 162.721 185.605 162.162 181.284L143.006 32.2997C142.454 27.9792 138.489 24.4762 134.16 24.4762V24.4762Z",
    fill: "url(#paint21_linear_27_2148)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M155.324 189.108H87.6264C83.2974 189.108 79.3389 185.605 78.7799 181.284L59.6245 32.2997C59.072 27.9792 62.127 24.4762 66.456 24.4762H134.153C138.482 24.4762 142.441 27.9792 143 32.2997L162.155 181.284C162.708 185.605 159.653 189.108 155.324 189.108Z",
    fill: "url(#paint22_linear_27_2148)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M155.324 189.108H87.6264C83.2974 189.108 79.3389 185.605 78.7799 181.284L59.6245 32.2997C59.072 27.9792 62.127 24.4762 66.456 24.4762H134.153C138.482 24.4762 142.441 27.9792 143 32.2997L162.155 181.284C162.708 185.605 159.653 189.108 155.324 189.108Z",
    fill: "url(#paint23_linear_27_2148)"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M114.257 30.4703H88.0359C86.1964 30.4703 84.3894 29.3805 83.4404 27.6938L78.2599 18.4885H120.945L118.137 27.6938C117.624 29.3805 116.096 30.4703 114.257 30.4703Z",
    fill: "url(#paint24_linear_27_2148)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M107.633 26.6364H88.5754C87.9774 26.6364 87.4314 26.1563 87.3534 25.5595C87.2754 24.9627 87.6979 24.4826 88.2959 24.4826H107.354C107.952 24.4826 108.498 24.9627 108.576 25.5595C108.654 26.1563 108.231 26.6364 107.633 26.6364Z",
    fill: "url(#paint25_linear_27_2148)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M113.333 26.6667C113.875 26.0891 113.782 25.1222 113.125 24.5071C112.468 23.8919 111.495 23.8615 110.952 24.439C110.41 25.0166 110.503 25.9835 111.16 26.5986C111.817 27.2138 112.79 27.2442 113.333 26.6667Z",
    fill: "url(#paint26_linear_27_2148)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8055 109.004H56.8555C55.3735 109.004 54.0215 107.804 53.8265 106.325L52.2015 93.688C52.013 92.2089 53.0595 91.0088 54.5415 91.0088H56.4915C57.9735 91.0088 59.3255 92.2089 59.5205 93.688L61.1455 106.325C61.334 107.804 60.2875 109.004 58.8055 109.004Z",
    fill: "url(#paint27_linear_27_2148)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8555 109.004C55.3735 109.004 54.0215 107.804 53.8265 106.325L52.2015 93.688C52.013 92.2089 53.0595 91.0088 54.5415 91.0088C56.0235 91.0088 57.3755 92.2089 57.5705 93.688L59.1955 106.325C59.384 107.804 58.3375 109.004 56.8555 109.004Z",
    fill: "url(#paint28_linear_27_2148)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5555 83.7301H53.6055C52.1235 83.7301 50.7715 82.53 50.5765 81.0509L48.9515 68.4139C48.763 66.9348 49.8095 65.7347 51.2915 65.7347H53.2415C54.7235 65.7347 56.0755 66.9348 56.2705 68.4139L57.8955 81.0509C58.084 82.53 57.0375 83.7301 55.5555 83.7301Z",
    fill: "url(#paint29_linear_27_2148)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6055 83.7301C52.1235 83.7301 50.7715 82.53 50.5765 81.0509L48.9515 68.4139C48.763 66.9348 49.8095 65.7347 51.2915 65.7347C52.7735 65.7347 54.1255 66.9348 54.3205 68.4139L55.9455 81.0509C56.134 82.53 55.0875 83.7301 53.6055 83.7301Z",
    fill: "url(#paint30_linear_27_2148)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M155.168 77.4959H102.953C99.4108 77.4959 96.8823 80.3633 97.2983 83.8988L104.253 143.503L114.302 132.592H162.246L155.161 77.5024L155.168 77.4959Z",
    fill: "url(#paint31_linear_27_2148)"
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M199.342 67.8041H125.963C119.522 67.8041 114.302 73.0133 114.302 79.4421V141.2L127.146 130.172H199.342C205.783 130.172 211.003 124.963 211.003 118.534V79.4421C211.003 73.0133 205.783 67.8041 199.342 67.8041V67.8041Z",
    fill: "url(#paint32_linear_27_2148)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M199.342 67.8041H125.963C119.522 67.8041 114.302 73.0133 114.302 79.4421V141.2L127.146 130.172H199.342C205.783 130.172 211.003 124.963 211.003 118.534V79.4421C211.003 73.0133 205.783 67.8041 199.342 67.8041V67.8041Z",
    stroke: "url(#paint33_linear_27_2148)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M190.502 74.2588H130.208C126.665 74.2588 123.792 77.1255 123.792 80.6617V115.816C123.792 119.352 126.665 122.219 130.208 122.219H190.502C194.045 122.219 196.917 119.352 196.917 115.816V80.6617C196.917 77.1255 194.045 74.2588 190.502 74.2588Z",
    fill: "url(#paint34_linear_27_2148)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M194.46 74.2588H134.166C130.623 74.2588 127.751 77.1255 127.751 80.6617V115.816C127.751 119.352 130.623 122.219 134.166 122.219H194.46C198.003 122.219 200.876 119.352 200.876 115.816V80.6617C200.876 77.1255 198.003 74.2588 194.46 74.2588Z",
    fill: "url(#paint35_linear_27_2148)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M164.313 93.7658L129.597 120.778C130.585 121.667 131.891 122.219 133.334 122.219H195.292C196.729 122.219 198.035 121.674 199.03 120.778L164.313 93.7658V93.7658Z",
    fill: "url(#paint36_linear_27_2148)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M164.313 102.705L199.03 75.6925C198.042 74.8038 196.735 74.2523 195.292 74.2523H133.334C131.898 74.2523 130.591 74.7973 129.597 75.6925L164.313 102.705Z",
    fill: "url(#paint37_linear_27_2148)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M129.603 75.6925L164.313 102.705L199.03 75.6925",
    stroke: "#CC5833",
    strokeWidth: 1.44,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M194.785 88.5631C202.701 88.5631 209.118 82.1589 209.118 74.2588C209.118 66.3588 202.701 59.9546 194.785 59.9546C186.87 59.9546 180.453 66.3588 180.453 74.2588C180.453 82.1589 186.87 88.5631 194.785 88.5631Z",
    fill: "#D4003C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M196.67 88.5631C204.586 88.5631 211.003 82.1589 211.003 74.2588C211.003 66.3588 204.586 59.9546 196.67 59.9546C188.755 59.9546 182.338 66.3588 182.338 74.2588C182.338 82.1589 188.755 88.5631 196.67 88.5631Z",
    fill: "#FF335B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M199.979 81.3818H197.216V69.5881L194.623 69.6529V67.5381L199.979 66.9932V81.3753V81.3818Z",
    fill: "#D4003C"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M198.698 81.3818H195.962V69.7048L193.394 69.7697V67.6743L198.698 67.1359V81.3818V81.3818Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M196.67 44.288V52.9549",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M217.906 53.0652L211.763 59.1956",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M226.7 74.2588H218.016",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M175.441 53.0652L181.577 59.1956",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1055 13.6296L41.223 18.5988",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4819 1.29744L54.9964 9.83458",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9199 6.24716L70.9474 13.3506",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M29.146 36.0298L37.6935 34.5183",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27_2148",
    x1: 136.721,
    y1: 26.604,
    x2: 74.8177,
    y2: 202.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#017774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#076879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#104F81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#164186"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_27_2148",
    x1: 154.42,
    y1: 48.6734,
    x2: 154.42,
    y2: 96.5488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#017774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#076879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#104F81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#164186"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_27_2148",
    x1: 118.566,
    y1: 23.0749,
    x2: 103.953,
    y2: 183.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ADECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1697D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_27_2148",
    x1: 127.406,
    y1: 9.75023,
    x2: 93.3213,
    y2: 210.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#BBDCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0CFD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_27_2148",
    x1: 124.41,
    y1: 27.4732,
    x2: 66.43,
    y2: 27.4732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#017774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#076879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#104F81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#164186"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_27_2148",
    x1: 118.566,
    y1: 23.0749,
    x2: 103.953,
    y2: 183.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ADECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1697D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_27_2148",
    x1: 127.406,
    y1: 9.75023,
    x2: 93.3213,
    y2: 210.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#BBDCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0CFD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_27_2148",
    x1: 71.4154,
    y1: 70.0292,
    x2: 237.698,
    y2: 70.0292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ADECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1697D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_27_2148",
    x1: 71.9029,
    y1: 43.8209,
    x2: 238.186,
    y2: 43.8209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ADECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1697D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_27_2148",
    x1: 18.2651,
    y1: 95.9131,
    x2: 124.364,
    y2: 95.9131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ADECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1697D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_27_2148",
    x1: 71.4155,
    y1: 121.803,
    x2: 237.698,
    y2: 121.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ADECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1697D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_27_2148",
    x1: 18.265,
    y1: 147.694,
    x2: 124.364,
    y2: 147.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ADECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1697D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_27_2148",
    x1: 202.208,
    y1: 170.276,
    x2: 129.915,
    y2: 170.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ADECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1697D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_27_2148",
    x1: 120.445,
    y1: 213.201,
    x2: 149.245,
    y2: 162.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ADECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1697D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_27_2148",
    x1: 99.4888,
    y1: 79.468,
    x2: 99.4888,
    y2: -2.51055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#017774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#076879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#104F81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#164186"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_27_2148",
    x1: 124.41,
    y1: 27.4732,
    x2: 66.43,
    y2: 27.4732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#017774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#076879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#104F81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#164186"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_27_2148",
    x1: 146.458,
    y1: 19.8897,
    x2: 146.458,
    y2: 181.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#017774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#076879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#104F81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#164186"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_27_2148",
    x1: 203.879,
    y1: 60.1751,
    x2: 8.21579,
    y2: 158.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ECE3AC",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#BCCEAC",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#6EACAB",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#057DAA",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007BAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_27_2148",
    x1: 99.3458,
    y1: 21.3234,
    x2: 84.7326,
    y2: 181.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ADECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1697D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_27_2148",
    x1: 124.41,
    y1: 25.5595,
    x2: 66.4299,
    y2: 25.5595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#017774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#076879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#104F81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#164186"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_27_2148",
    x1: 124.403,
    y1: 25.5601,
    x2: 66.4235,
    y2: 25.5602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#017774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#076879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#104F81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#164186"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_27_2148",
    x1: 146.458,
    y1: 19.8897,
    x2: 146.458,
    y2: 181.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#017774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#076879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#104F81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#164186"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_27_2148",
    x1: 203.879,
    y1: 60.1751,
    x2: 8.21579,
    y2: 158.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ECE3AC",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#BCCEAC",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#6EACAB",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#057DAA",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007BAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_27_2148",
    x1: 182.981,
    y1: 201.602,
    x2: 52.1589,
    y2: 28.8727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACDC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CDBCB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#C59B9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#BB6A81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#9E5574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#634A66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#253C4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#052C35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_27_2148",
    x1: 99.3458,
    y1: 21.3234,
    x2: 84.7326,
    y2: 181.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ADECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1697D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_27_2148",
    x1: 124.41,
    y1: 25.5595,
    x2: 66.4299,
    y2: 25.5595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#017774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#076879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#104F81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#164186"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_27_2148",
    x1: 124.403,
    y1: 25.5601,
    x2: 66.4235,
    y2: 25.5602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#017774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#076879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#104F81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#164186"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_27_2148",
    x1: 56.6735,
    y1: 30.1784,
    x2: 56.6735,
    y2: 168.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ADECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1697D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_27_2148",
    x1: -18.3233,
    y1: 100.006,
    x2: 68.2435,
    y2: 100.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#017774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#076879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#104F81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#164186"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_27_2148",
    x1: 53.4235,
    y1: 30.1784,
    x2: 53.4235,
    y2: 168.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ADECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1697D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_27_2148",
    x1: -18.3234,
    y1: 74.7324,
    x2: 68.2435,
    y2: 74.7324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#017774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#076879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#104F81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#164186"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_27_2148",
    x1: 100.886,
    y1: 110.503,
    x2: 173.218,
    y2: 110.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACDC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CDBCB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#C59B9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#BB6A81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#9E5574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#634A66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#253C4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#052C35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_27_2148",
    x1: 114.302,
    y1: 104.502,
    x2: 211.009,
    y2: 104.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#C5EEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_27_2148",
    x1: 121.056,
    y1: 66.9672,
    x2: 194.594,
    y2: 140.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1697D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADECE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_27_2148",
    x1: 164.411,
    y1: 80.6941,
    x2: 152.56,
    y2: 132.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F88C57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D55A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE5021"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_27_2148",
    x1: 164.183,
    y1: 139.105,
    x2: 164.358,
    y2: 85.6244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6DE55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F5D354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F5B654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5AE54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_27_2148",
    x1: 154.381,
    y1: 172.189,
    x2: 166.891,
    y2: 107.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6DE55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F5D354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F5B654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5AE54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_27_2148",
    x1: 164.554,
    y1: 68.7966,
    x2: 162.831,
    y2: 118.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6DE55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F5D354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F5B654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5AE54"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_2148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 228,
    height: 240,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.0ed38c5444af55361442035cb867b353.svg";
export { ForwardRef as ReactComponent };